import React from "react";

import { css } from "@emotion/core";

import { Colors } from "@zapier/design-system";

import { flags } from "./flags";

type FlagIconProps = {
  /** The flag to display. */
  name?: any;
};

const iconWrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  padding: 7.5px 5px;
  border: 1px solid ${Colors.neutral300};
`;

/**
 * An icon representing a country's flag.
 */
export const FlagIcon = ({ name }: FlagIconProps) => {
  /* Placeholder flag 'Unknown' handles cases where a currency is added to the Teller API
  before we can update the currency package in all consumers */

  //@ts-ignore
  const Flag = name ? flags[name] : flags.Unknown;

  return (
    <div css={iconWrapper}>
      <Flag />
    </div>
  );
};
